import React from 'react';
import { Redirect } from 'react-router-dom';
import { User, UserByIdQuery } from 'schema';
import { Loading } from 'ui/Loading';

interface EditFormOrEmptyProps {
  onClose: () => void;
  loading: boolean;
  hasError: boolean;
  data?: UserByIdQuery;
}

type ComponentProps = {
  onClose: () => void;
  user: User;
};

export const EditFormOrEmpty = <P extends EditFormOrEmptyProps>(
  Component: React.ComponentType<P & ComponentProps>
) => {
  return (props: P) => {
    const { onClose, loading, hasError, data } = props;

    if (loading) {
      return <Loading />;
    }
    if (hasError) {
      return <Redirect to="/404" />;
    }
    if (data === undefined || data.userById === undefined) {
      return <Redirect to="/404" />;
    }

    const user = data?.userById as User;

    return <Component {...props} onClose={onClose} user={user} />;
  };
};
